import { WORKFLOW_MODULE_ID } from 'constants/workflow.constants';
import {
  GenericWorkflowModuleFieldModuleConfig,
  WorkflowModuleFieldConfig,
  WorkflowModuleFieldModuleConfig,
  WorkflowModuleTabInterface,
} from 'interfaces/testing-workflow.interface';
import { STEP_TYPES_NAMES } from 'constants/status.constants';
import { DateFormatPipe } from '@certemy/common';
import { HISTORY_TYPES_MAP } from 'constants/constants';
import { SmartTable } from '@certemy/ui-components';
import { JOB_STATE_TYPE } from 'pages/verifier/list/jobs-list.interface';

export const WORKFLOW_MODULE_TABS: WorkflowModuleTabInterface = {
  ['certemy-tasks']: {
    tabs: [
      {
        display: 'TO DO LIST',
        link: './todo',
      },
      {
        display: 'PRIMARY VERIFICATION LIST',
        link: './primary-verification',
      },
      {
        display: 'SECONDARY VERIFICATION LIST',
        link: './secondary-verification',
      },
    ],
  },
  [WORKFLOW_MODULE_ID.TESTING_WORKFLOW]: {
    tabs: [
      {
        display: 'TO DO LIST',
        link: './todo',
      },
      {
        display: 'VERIFICATION LIST',
        link: './verification',
      },
    ],
  },
  [WORKFLOW_MODULE_ID.COMPLIANCE]: {
    tabs: [
      {
        display: 'TO DO LIST',
        link: './todo',
      },
      {
        display: 'PRIMARY VERIFICATION LIST',
        link: './verification',
        queryParams: {
          jobStateTypeIds: JOB_STATE_TYPE.PRIMARY,
        },
      },
      {
        display: 'SECONDARY VERIFICATION LIST',
        link: './verification',
        queryParams: {
          jobStateTypeIds: JOB_STATE_TYPE.SECONDARY,
        },
      },
    ],
  },
};

export const HEADERS_FIELDS: WorkflowModuleFieldConfig[] = [
  {
    label: 'Phase',
    param: 'phaseName',
  },
  {
    label: 'Step type',
    param: 'typeId',
    constPrefix: STEP_TYPES_NAMES,
  },
  {
    label: 'Workflow',
    param: 'workflowName',
  },
  {
    label: 'Received date',
    param: 'receivedDate',
  },
  {
    label: 'Due date',
    param: 'dueDate',
  },
];

export const GENERIC_INFO_FIELDS: GenericWorkflowModuleFieldModuleConfig = {
  ['certemy-tasks']: [
    {
      label: 'Phase name',
      param: 'phaseName',
    },
    {
      label: 'Step name',
      param: 'stepName',
    },
    {
      label: 'Step start date',
      param: 'startDate',
    },
    {
      label: 'Step due date',
      param: 'dueDate',
    },
  ],
};

export const INFO_FIELDS: WorkflowModuleFieldModuleConfig = {
  [WORKFLOW_MODULE_ID.TESTING_WORKFLOW]: [
    {
      label: 'Workflow Name',
      param: 'workflowName',
    },
    {
      label: 'Testing Provider',
      param: 'testingProviderName',
    },
    {
      label: 'Exam Name',
      param: 'name',
    },
    {
      label: 'Exam Code',
      param: 'code',
    },
    {
      label: 'Due date',
      param: 'dueDate',
    },
    {
      label: 'Phase',
      param: 'phaseName',
    },
    {
      label: 'Step',
      param: 'stepName',
    },
    {
      label: 'Exam Date',
      param: 'date',
    },
    {
      label: 'Exam Time',
      param: 'examTime_tz',
    },
    {
      label: 'Attempt #',
      param: 'attempt',
    },
  ],
  [WORKFLOW_MODULE_ID.COMPLIANCE]: [
    {
      label: 'Phase name',
      param: 'phaseName',
    },
    {
      label: 'Step name',
      param: 'stepName',
    },
    {
      label: 'Step start date',
      param: 'startDate',
    },
    {
      label: 'Step due date',
      param: 'dueDate',
    },
  ],
};

export const GENERIC_PROF_FIELDS: GenericWorkflowModuleFieldModuleConfig = {
  ['certemy-tasks']: [
    {
      label: 'Professional',
      param: 'name',
    },
    {
      label: 'Email',
      param: 'email',
    },
  ],
};

export const PROF_FIELDS: WorkflowModuleFieldModuleConfig = {
  [WORKFLOW_MODULE_ID.TESTING_WORKFLOW]: [
    {
      label: 'Professional',
      param: 'name',
    },
    {
      label: 'Email',
      param: 'email',
    },
    {
      label: 'Candidate ID',
      param: 'candidateId',
    },
    {
      label: 'Board Name',
      param: 'organizationName',
    },
  ],
  [WORKFLOW_MODULE_ID.COMPLIANCE]: [
    {
      label: 'Professional',
      param: 'name',
    },
    {
      label: 'Email',
      param: 'email',
    },
  ],
};

export const HISTORY_FIELDS: WorkflowModuleFieldConfig[] = [
  {
    label: '',
    param: 'createdAt',
    transform: date => new DateFormatPipe().transform(date, 'dateTime'),
  },
  {
    label: '',
    param: 'typeId',
    constPrefix: HISTORY_TYPES_MAP,
  },
  {
    label: '',
    param: 'createdBy',
  },
  {
    label: '',
    param: 'role',
  },
];

export enum STATUS_INDICATOR_TYPES {
  PRIORITY,
  STEP,
}

export const WORKFLOW_MODULE_POLICY_PERMISSIONS = {
  ['certemy-tasks']: {
    TODO_LIST: {
      name: 'todoList',
      url: 'management/certemy_tasks/todo',
      action: 'access',
    },
    PRIMARY_VERIFICATION_LIST: {
      name: 'primaryVerificationList',
      url: 'management/certemy_tasks/primary_verification',
      action: 'access',
    },
    SECONDARY_VERIFICATION_LIST: {
      name: 'secondaryVerificationList',
      url: 'management/certemy_tasks/secondary_verification',
      action: 'access',
    },
  },
  [WORKFLOW_MODULE_ID.TESTING_WORKFLOW]: {
    TODO_LIST: { name: 'todoList', url: 'testing/todo_verification/all', action: 'access' },
    VERIFICATION_LIST: { name: 'verificationList', url: 'testing/primary_verification/all', action: 'access' },
  },
  [WORKFLOW_MODULE_ID.COMPLIANCE]: {
    TODO_LIST: { name: 'todoList', url: 'compliance/todo_verification/all', action: 'access' },
    PRIMARY_VERIFICATION_LIST: {
      name: 'primaryVerificationList',
      url: 'compliance/primary_verification/all',
      action: 'access',
    },
    SECONDARY_VERIFICATION_LIST: {
      name: 'secondaryVerificationList',
      url: 'compliance/secondary_verification/all',
      action: 'access',
    },
  },
};

export enum COMPLIANCE_FILTER_TYPE_ID {
  CREDENTIAL_TYPE = 1,
  WORKFLOW_NAME = 2,
  CREDENTIAL_NAME = 3,
  STEP_TYPE = 4,
  ASSIGNEE = 5,
  ORGANIZATION = 6,
}

export class WorkflowListFilter<T> {
  constructor(search = '', filters?: T) {
    this.search = search;
    this.filters = filters;
  }
  search = '';
  orderId = 'name';
  orderType = SmartTable.Order.ASC;
  filters: T;
}

export interface ExamInfoConfig {
  title?: string;
  fieldConfig?: WorkflowModuleFieldConfig[];
  descriptionParamName?: string;
}

export interface ProfessionalInfoConfig {
  fieldConfig?: WorkflowModuleFieldConfig[];
  title?: string;
  profileIdParamName?: string;
  organizationIdParamName?: string;
}

export const COMPLIANCE_DEFAULTS_FILTER_VALUES = {
  credentialTypeId: 'All',
  stepTypeId: 'All',
  countryId: 'All',
  regionId: 'All',
  officeId: 'All',
  assigneeId: 'Everyone',
  organizationId: 'All',
};

export interface ProfileAndOrganization {
  profileId: number;
  organizationId: number;
  isRegistryLink?: boolean
}
